var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// libs/embed-libs/shared-embed/src/lib/helpers/error.ts
var _handleError = (errorMessage, parameters) => {
  let message = "The dashboard component encountered an error";
  if (typeof parameters?.dashboardId === "string") {
    message += ` for dashboard with id ${parameters.dashboardId}`;
  }
  if (typeof parameters?.dashboardSlug === "string") {
    message += ` for dashboard with slug ${parameters.dashboardSlug}`;
  }
  if (typeof parameters?.container === "string") {
    message += ` in container ${parameters.container}`;
  }
  if (errorMessage) {
    message += `:
${errorMessage}`;
    console.error(message);
  }
};

// libs/embed-libs/shared-embed/src/lib/helpers/browser-check.ts
var _browserCheck = (dashboardComponent) => {
  let hasError = false;
  let errorMessage = "";
  const document_ = document.body || document.documentElement;
  const style = document_.style;
  const browserCheck = {
    svg: !!("createElementNS" in document && document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect),
    flexbox: style.webkitFlexWrap === "" || style.flexWrap === "",
    postMessage: !!window.postMessage
  };
  const browserCheckKeys = ["svg", "flexbox", "postMessage"];
  for (const key of browserCheckKeys) {
    if (!browserCheck[key]) {
      hasError = true;
      dashboardComponent.browserNotSupported = dashboardComponent.browserNotSupported || [];
      dashboardComponent.browserNotSupported.push(key);
      errorMessage += `Your browser does not support: ${key}
`;
    }
  }
  const ua = window.navigator.userAgent;
  const msie = ua.includes("MSIE");
  const trident = ua.includes("Trident/");
  if (msie || trident) {
    hasError = true;
    errorMessage = "IE is not supported.";
  }
  if (hasError) {
    _handleError(errorMessage);
  }
};

// libs/embed-libs/shared-embed/src/lib/helpers/default-parameters.ts
var DEFAULT_PARAMETERS = {
  appServer: "https://app.luzmo.com/",
  apiHost: "https://api.luzmo.com/",
  dashboardId: null,
  dashboardSlug: null,
  container: null,
  key: null,
  token: null,
  language: "auto",
  qeVersion: null,
  editMode: null,
  screenMode: null,
  switchScreenModeOnResize: true,
  itemId: null,
  mainColor: "",
  accentColor: "",
  itemDimensions: {
    width: "auto",
    height: "auto"
  },
  loaderBackground: "#f9f9f9",
  loaderFontColor: "#5a5a5a",
  loaderSpinnerColor: "rgba(255, 165, 0, 0.7)",
  loaderSpinnerBackground: "rgba(169, 169, 169, 0.14)",
  timezoneId: null,
  contextId: null
};

// libs/embed-libs/shared-embed/src/lib/helpers/extents.ts
var EXTENTS = [
  { mode: "mobile", width: [150, 767] },
  { mode: "tablet", width: [768, 1199] },
  { mode: "desktop", width: [1200, 1599] },
  { mode: "largeScreen", width: [1600, 9999] },
  { mode: "fixed", width: [] }
];

// libs/embed-libs/shared-embed/src/lib/helpers/translations.ts
var TRANSLATIONS = {
  initializing: { en: "Initializing...", nl: "Laden...", fr: "Chargement..." },
  errorDashboard: {
    en: "Oops, we could not load this dashboard!",
    nl: "Oeps, we konden het dashboard niet laden.",
    fr: "Le chargement a echou\xE9."
  },
  errorItem: {
    en: "Oops, we could not load this item!",
    nl: "Oeps, we konden de grafiek niet laden.",
    fr: "Le chargement a echou\xE9."
  }
};
var translations_default = TRANSLATIONS;

// libs/embed-libs/shared-embed/src/lib/helpers/utils.ts
var addTrailingSlash = (serverUrl) => {
  if (!serverUrl) {
    return "";
  }
  return serverUrl.endsWith("/") ? serverUrl : `${serverUrl}/`;
};
var removeTrailingSlash = (serverUrl) => {
  if (!serverUrl) {
    return "";
  }
  return serverUrl.endsWith("/") ? serverUrl.slice(0, -1) : serverUrl;
};
var formatDashboardList = (dashboards, integrationId, user, dashboardComponent) => {
  const combineRights = (securable, user2) => {
    const matchingUser = securable.users.find((u) => u.id === user2.id);
    const securableAccessRights = matchingUser && matchingUser.userAccessRight ? {
      flagRead: matchingUser.userAccessRight.flagRead,
      flagUse: matchingUser.userAccessRight.flagUse,
      flagModify: matchingUser.userAccessRight.flagModify,
      flagOwn: matchingUser.userAccessRight.flagOwn
    } : {
      flagRead: false,
      flagUse: false,
      flagModify: false,
      flagOwn: false
    };
    const groups = securable.groups.filter(
      (group) => user2.userGroups.includes(group.id) || group.public === true
    );
    const groupsAccess = groups.map((group) => {
      if (group.groupAccessRight) {
        return group.groupAccessRight;
      }
    });
    for (const groupAccess of groupsAccess) {
      if (!securableAccessRights.flagRead && groupAccess.flagRead) {
        securableAccessRights.flagRead = groupAccess.flagRead;
      }
      if (!securableAccessRights.flagUse && groupAccess.flagUse) {
        securableAccessRights.flagUse = groupAccess.flagUse;
      }
      if (!securableAccessRights.flagModify && groupAccess.flagModify) {
        securableAccessRights.flagModify = groupAccess.flagModify;
      }
      if (!securableAccessRights.flagOwn && groupAccess.flagOwn) {
        securableAccessRights.flagOwn = groupAccess.flagOwn;
      }
    }
    const integrationsAccess = securable.integrations?.length > 0 ? securable.integrations.map((integration) => {
      if (integration.integrationAccessRight) {
        return integration.integrationAccessRight;
      }
    }) : [];
    for (const integrationAccess of integrationsAccess) {
      if (!securableAccessRights.flagRead && integrationAccess.flagRead) {
        securableAccessRights.flagRead = integrationAccess.flagRead;
      }
      if (!securableAccessRights.flagUse && integrationAccess.flagUse) {
        securableAccessRights.flagUse = integrationAccess.flagUse;
      }
      if (!securableAccessRights.flagModify && integrationAccess.flagModify) {
        securableAccessRights.flagModify = integrationAccess.flagModify;
      }
    }
    return securableAccessRights;
  };
  const localize = (item, locale) => {
    if (item === null || item === void 0) {
      return "";
    }
    if (typeof item !== "object" || Object.keys(item).length === 0) {
      if (typeof item === "object" && Object.keys(item).length === 0) {
        return "";
      }
      return item;
    }
    let localizedItem;
    localizedItem = locale && item[locale] ? item[locale] : item[Object.keys(item)[0]];
    if (localizedItem === void 0 || localizedItem === null) {
      localizedItem = "";
    }
    return localizedItem;
  };
  const treatedDashboards = [];
  for (const dashboard of dashboards) {
    const treatedDashboard = {
      accessibleBy: [],
      accessRights: combineRights(dashboard, user),
      id: dashboard.id,
      modifiedAt: dashboard.modified_at,
      name: localize(dashboard.name, dashboardComponent.language),
      slug: null,
      tags: dashboard.tags.map((t) => t.tag).sort((t1, t2) => t1.localeCompare(t2))
    };
    const currentIntegration = dashboard.integrations.find(
      (i) => i.id === integrationId
    );
    if (currentIntegration?.integrationAccessRight?.slug) {
      treatedDashboard.slug = currentIntegration.integrationAccessRight.slug;
    }
    const users = dashboard.users.map((u) => ({
      model: "User",
      id: u.id,
      name: localize(u.name, user.locale_id)
    }));
    const groups = dashboard.groups.map((g) => ({
      model: "Group",
      id: g.id,
      name: localize(g.name, user.locale_id) || {}
    }));
    const integrations = dashboard.integrations.map((i) => ({
      model: "Integration",
      id: i.id,
      name: localize(i.name, user.locale_id) || {}
    }));
    treatedDashboard.accessibleBy = [...users, ...groups, ...integrations];
    treatedDashboards.push(treatedDashboard);
  }
  return treatedDashboards;
};
var VERSION = "0.0.0-shared-luzmo";
var sanitizeUrl = (url) => {
  const invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
  const ctrlCharactersRegex = /[^\u0020-\u007E]/gim;
  const urlSchemeRegex = /^([^:]+):/gm;
  const relativeFirstCharacters = /* @__PURE__ */ new Set([".", "/"]);
  const isRelativeUrlWithoutProtocol = (relativeUrl) => relativeFirstCharacters.has(relativeUrl[0]);
  if (!url) {
    return "about:blank";
  }
  const sanitizedUrl = url.replaceAll(ctrlCharactersRegex, "").trim();
  if (isRelativeUrlWithoutProtocol(sanitizedUrl)) {
    return sanitizedUrl;
  }
  const urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
  if (!urlSchemeParseResults) {
    return sanitizedUrl;
  }
  const urlScheme = urlSchemeParseResults[0];
  if (invalidPrototcolRegex.test(urlScheme)) {
    return "about:blank";
  }
  return sanitizedUrl;
};
var cloneDeep = (obj) => JSON.parse(JSON.stringify(obj));
var isObject = (o) => o && typeof o === "object";
var defaultsDeep = (target, defaults) => {
  Object.entries(defaults).forEach(([k, v]) => {
    if (k in target) {
      if (target[k] === void 0) {
        target[k] = v;
      } else {
        target[k] = isObject(v) ? defaultsDeep(
          target[k],
          v
        ) : target[k];
      }
    } else {
      target[k] = v;
    }
  });
  return target;
};
var uuidv4 = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replaceAll(/[xy]/g, function(c) {
  const r = Math.random() * 16 | 0;
  const v = c == "x" ? r : r & 3 | 8;
  return v.toString(16);
});

// libs/embed-libs/shared-embed/src/lib/helpers/iframe-url.ts
var createIframeUrl = (dashboardContent) => {
  const searchString = [];
  const {
    appServer,
    language,
    qeVersion,
    loaderBackground,
    loaderSpinnerColor,
    loaderSpinnerBackground,
    loaderFontColor,
    screenMode,
    key,
    token,
    timezoneId,
    itemEmbedding,
    itemDimensions,
    dashboardId,
    dashboardSlug,
    itemId,
    mainColor,
    accentColor,
    editMode
  } = dashboardContent.params;
  if (language && language !== "auto") {
    searchString.push("language=" + language);
  }
  if (qeVersion) {
    searchString.push(`qe_version=${qeVersion}`);
  }
  if (loaderBackground) {
    searchString.push(`ldrbg=${loaderBackground}`);
  }
  if (loaderFontColor) {
    searchString.push(`ldrftclr=${loaderFontColor}`);
  }
  if (loaderSpinnerColor) {
    searchString.push(`ldrspclr=${loaderSpinnerColor}`);
  }
  if (loaderSpinnerBackground) {
    searchString.push(`ldrspbg=${loaderSpinnerBackground}`);
  }
  if (mainColor) {
    searchString.push(`mainColor=${mainColor}`);
  }
  if (accentColor) {
    searchString.push(`accentColor=${accentColor}`);
  }
  if (screenMode && screenMode !== "auto") {
    searchString.push("screenMode=" + screenMode);
  }
  if (timezoneId) {
    searchString.push("timezoneId=" + timezoneId);
  }
  if (itemEmbedding && itemDimensions && itemDimensions.width) {
    searchString.push("width=" + itemDimensions.width);
  }
  if (itemEmbedding && itemDimensions && itemDimensions.height) {
    searchString.push("height=" + itemDimensions.height);
  }
  if (editMode) {
    searchString.push("editMode=" + editMode);
  }
  const keyTokenUrlAnchor = key && token ? "#" + key + ":" + token : "";
  searchString.push("version=" + (dashboardContent.VERSION || VERSION));
  const iframeUrl = itemEmbedding ? `${appServer}i/${dashboardId || dashboardSlug}/${itemId}?${encodeURIComponent(
    searchString.join("&")
  )}${keyTokenUrlAnchor}` : `${appServer}i/${dashboardId || dashboardSlug}?${encodeURIComponent(
    searchString.join("&")
  )}${keyTokenUrlAnchor}`;
  return sanitizeUrl(iframeUrl);
};

// libs/embed-libs/shared-embed/src/lib/helpers/get-loader.ts
var getLoader = (dashboardComponent) => {
  let errorMsg;
  if (dashboardComponent.params.error || dashboardComponent.browserNotSupported.length > 0) {
    dashboardComponent.params.error = true;
    if (dashboardComponent.browserNotSupported) {
      errorMsg = "Browser is not supported.";
    }
  }
  const loadingMsg = translations_default.initializing[dashboardComponent.params.language] || translations_default.initializing.en;
  return dashboardComponent.browserNotSupported || dashboardComponent.params.error ? { loadingMsg, errorMsg } : { loadingMsg, errorMsg: "" };
};

// libs/embed-libs/shared-embed/src/lib/helpers/promise-dispatch.ts
function resolvePromise(dashboardComponent, requestId, data) {
  if (dashboardComponent.promises[requestId]) {
    dashboardComponent.promises[requestId].resolve(data);
    delete dashboardComponent.promises[requestId];
  }
}
function rejectPromise(dashboardComponent, requestId, data) {
  if (dashboardComponent.promises[requestId]) {
    dashboardComponent.promises[requestId].reject(data);
    delete dashboardComponent.promises[requestId];
  }
}

// libs/embed-libs/shared-embed/src/lib/helpers/styles.ts
function containerStyles(dashboardComponent) {
  const styles = {};
  if (dashboardComponent.params.loaderBackground && !dashboardComponent.iframeLoaded) {
    styles.background = dashboardComponent.params.loaderBackground;
  }
  return styles;
}
function containerLoaderStyles(dashboardComponent) {
  const height = dashboardComponent.params.itemDimensions?.height || DEFAULT_PARAMETERS.itemDimensions.height;
  const chartHeightDefined = dashboardComponent.params.itemEmbedding && height !== "auto";
  const display = dashboardComponent.iframeLoaded ? "none" : "";
  return {
    display,
    height: `${chartHeightDefined ? height : dashboardComponent.minHeight}px`
  };
}
function loaderStyles(dashboardComponent) {
  const background = dashboardComponent.params.loaderBackground || DEFAULT_PARAMETERS.loaderBackground;
  if (dashboardComponent.params.itemEmbedding) {
    dashboardComponent.loaderSize = 24;
    dashboardComponent.borderWidth = 4;
    dashboardComponent.minHeight = 200;
    const width = dashboardComponent.params.itemDimensions?.width || DEFAULT_PARAMETERS.itemDimensions.width;
    const height = dashboardComponent.params.itemDimensions?.height || DEFAULT_PARAMETERS.itemDimensions.height;
    const chartWidthDefined = width !== "auto";
    const chartHeightDefined = height !== "auto";
    return {
      background,
      width: chartWidthDefined ? `${width}px` : "100%",
      height: `${chartHeightDefined ? height : "200"}px`,
      "min-height": chartHeightDefined ? "" : "200px"
    };
  }
  return {
    background
  };
}
function plStyles(dashboardComponent) {
  const {
    loaderSpinnerColor: defaultSpinnerColor,
    loaderSpinnerBackground: defaultSpinnerBackground
  } = DEFAULT_PARAMETERS;
  const spinnerColorBorder = generateBorderStyle(
    dashboardComponent.borderWidth,
    dashboardComponent.params.loaderSpinnerColor || defaultSpinnerColor
  );
  const spinnerBackgroundBorder = generateBorderStyle(
    dashboardComponent.borderWidth,
    dashboardComponent.params.loaderSpinnerBackground || defaultSpinnerBackground
  );
  const size = `${dashboardComponent.loaderSize}px`;
  return {
    "border-top": spinnerColorBorder,
    "border-right": spinnerColorBorder,
    "border-bottom": spinnerBackgroundBorder,
    "border-left": spinnerBackgroundBorder,
    width: size,
    height: size
  };
}
function lcStyles(dashboardComponent) {
  const height = dashboardComponent.params.itemDimensions?.height || DEFAULT_PARAMETERS.itemDimensions.height;
  const chartHeightDefined = dashboardComponent.params.itemEmbedding && height !== "auto";
  const getPaddingStr = (value) => `${(value - dashboardComponent.loaderSize - 32) / 2}px`;
  const verticalPadding = dashboardComponent.params.itemId ? chartHeightDefined ? getPaddingStr(Number.parseInt(`${height}`, 10)) : getPaddingStr(dashboardComponent.minHeight) : "128px";
  return {
    padding: `${verticalPadding} 16px`
  };
}
function calculateIframeStyles(dashboardComponent) {
  const height = dashboardComponent.params.itemDimensions?.height || DEFAULT_PARAMETERS.itemDimensions.height;
  const width = dashboardComponent.params.itemDimensions?.width || DEFAULT_PARAMETERS.itemDimensions.width;
  if (dashboardComponent.params.itemEmbedding && height !== "auto") {
    dashboardComponent.iframeHeight = `${height}px`;
  } else if (dashboardComponent.params.itemEmbedding) {
    dashboardComponent.iframeHeight = "200px";
  } else if (["editFull", "editLimited"].includes(dashboardComponent.params.editMode)) {
    dashboardComponent.iframeHeight = "100%";
  } else {
    dashboardComponent.iframeHeight = "400px";
  }
  dashboardComponent.iframeWidth = dashboardComponent.params.itemEmbedding && width !== "auto" ? `${width}px` : "100%";
  const styles = {
    height: dashboardComponent.iframeHeight,
    width: dashboardComponent.iframeWidth
  };
  if (dashboardComponent.iframeLoaded) {
    styles.opacity = 1;
  } else if (dashboardComponent.error) {
    styles.opacity = 1;
    styles.width = "100%";
    styles.height = "400px";
  } else {
    styles.opacity = 0;
  }
  return styles;
}
function generateBorderStyle(borderWidth, color) {
  return `${borderWidth}px solid ${color}`;
}

// libs/embed-libs/shared-embed/src/lib/helpers/update-iframe-url.ts
var updateIframeUrl = (iframe, iframeUrl) => {
  if (iframe?.contentWindow) {
    iframe.contentWindow.location.replace(iframeUrl);
  }
};

// libs/embed-libs/shared-embed/src/lib/methods/export-dashboard.ts
var exportDashboard = (dashboardComponent, iframe, format) => {
  const requestId = uuidv4();
  if (iframe?.contentWindow) {
    iframe.contentWindow.postMessage(
      {
        action: "exportDashboard",
        format: format || "png",
        _version: dashboardComponent.VERSION,
        requestId
      },
      "*"
    );
    return new Promise((resolve, reject) => {
      dashboardComponent.promises[requestId] = { resolve, reject };
      setTimeout(() => {
        if (dashboardComponent.promises[requestId]) {
          const errorMessage = "exportDashboard request timed out.";
          dashboardComponent.promises[requestId].reject(
            new Error(errorMessage)
          );
          delete dashboardComponent.promises[requestId];
        }
      }, 12e5);
    });
  }
  return Promise.reject(new Error("Cannot retrieve contentWindow."));
};

// libs/embed-libs/shared-embed/src/lib/methods/get-accessible-dashboards.ts
var getAccessibleDashboards = (dashboardComponent, iframe) => {
  if ((dashboardComponent.dashboardId || dashboardComponent.dashboardSlug) && iframe?.contentWindow) {
    const requestId = uuidv4();
    iframe.contentWindow.postMessage(
      {
        action: "getAccessibleDashboards",
        _version: dashboardComponent.VERSION,
        requestId
      },
      "*"
    );
    return new Promise((resolve, reject) => {
      dashboardComponent.promises[requestId] = { resolve, reject };
      setTimeout(() => {
        if (dashboardComponent.promises[requestId]) {
          const errorMessage = "getAccessibleDashboards request timed out.";
          dashboardComponent.promises[requestId].reject(
            new Error(errorMessage)
          );
          delete dashboardComponent.promises[requestId];
        }
      }, 2e3);
    });
  }
  const fetchUser = new Promise((resolve, reject) => {
    void (() => {
      try {
        const responsePromise = window.fetch(
          `${String(dashboardComponent.params.apiHost)}0.1.0/authorization`,
          {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            headers: { "Content-Type": "application/json" },
            redirect: "follow",
            body: JSON.stringify({
              action: "get",
              version: "0.1.0",
              key: dashboardComponent.authKey,
              token: dashboardComponent.authToken,
              find: {
                where: { id: dashboardComponent.authKey },
                attributes: ["id", "integration_id"],
                include: [
                  {
                    model: "User",
                    attributes: ["id", "name", "locale_id"],
                    include: [{ model: "Group" }]
                  }
                ]
              }
            })
          }
        );
        responsePromise.then((response) => response.json()).then((data) => {
          if (!data || !data.rows || data.rows.length === 0 || !data.rows[0].user || !data.rows[0].integration_id) {
            reject();
          } else {
            data.rows[0].user.userGroups = data.rows[0].user.groups.map(
              (group) => group.id
            );
            delete data.rows[0].user.groups;
            resolve({
              integrationId: data.rows[0].integration_id,
              user: data.rows[0].user
            });
          }
        });
      } catch (error) {
        reject(error);
      }
    })();
  });
  return new Promise((resolve, reject) => void (() => {
    try {
      fetchUser.then((authorizationData) => {
        const responsePromise = window.fetch(
          `${String(dashboardComponent.params.apiHost)}0.1.0/securable`,
          {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            headers: { "Content-Type": "application/json" },
            redirect: "follow",
            body: JSON.stringify({
              action: "get",
              version: "0.1.0",
              key: dashboardComponent.authKey,
              token: dashboardComponent.authToken,
              find: {
                where: { type: "dashboard", is_variant: false },
                attributes: ["id", "name", "modified_at"],
                order: [["modified_at", "desc"]],
                include: [
                  { model: "Tag", attributes: ["tag"] },
                  { model: "User", attributes: ["id", "name"] },
                  {
                    model: "Group",
                    attributes: ["id", "name", "public"]
                  },
                  { model: "Integration", attributes: ["id", "name"] }
                ]
              }
            })
          }
        );
        responsePromise.then((response) => response.json()).then((data) => {
          const dashboardList = data.rows.length > 0 ? formatDashboardList(
            data.rows,
            authorizationData.integrationId,
            authorizationData.user,
            dashboardComponent
          ) : [];
          resolve(dashboardList);
        });
      }).catch((error) => {
        reject(error);
      });
    } catch (error) {
      reject(error);
    }
  })());
};

// libs/embed-libs/shared-embed/src/lib/methods/get-data.ts
var getData = (dashboardComponent, iframe, itemId) => {
  if (iframe?.contentWindow) {
    const requestId = uuidv4();
    iframe.contentWindow.postMessage(
      {
        action: "getData",
        id: itemId,
        _version: dashboardComponent.VERSION,
        requestId
      },
      "*"
    );
    return new Promise((resolve, reject) => {
      dashboardComponent.promises[requestId] = { resolve, reject };
      setTimeout(() => {
        if (dashboardComponent.promises[requestId]) {
          const errorMessage = "getData request timed out.";
          dashboardComponent.promises[requestId].reject(
            new Error(errorMessage)
          );
          delete dashboardComponent.promises[requestId];
        }
      }, 2e3);
    });
  }
  return Promise.reject(new Error("Cannot retrieve contentWindow."));
};

// libs/embed-libs/shared-embed/src/lib/methods/get-filters.ts
var getFilters = (dashboardComponent, iframe) => {
  if (iframe?.contentWindow) {
    const requestId = uuidv4();
    iframe.contentWindow.postMessage(
      { action: "getFilters", _version: dashboardComponent.VERSION, requestId },
      "*"
    );
    return new Promise((resolve, reject) => {
      dashboardComponent.promises[requestId] = { resolve, reject };
      setTimeout(() => {
        if (dashboardComponent.promises[requestId]) {
          const errorMessage = "getFilters request timed out.";
          dashboardComponent.promises[requestId].reject(
            new Error(errorMessage)
          );
          delete dashboardComponent.promises[requestId];
        }
      }, 2e3);
    });
  }
  return Promise.reject(new Error("Cannot retrieve contentWindow."));
};

// libs/embed-libs/shared-embed/src/lib/methods/refresh-data.ts
var refreshData = (dashboardComponent, iframe, itemId) => {
  if (iframe) {
    iframe.contentWindow.postMessage(
      {
        action: "refreshData",
        id: itemId ?? null,
        _version: dashboardComponent.VERSION
      },
      "*"
    );
    return Promise.resolve();
  }
  return Promise.reject(new Error("Cannot retrieve contentWindow."));
};

// libs/embed-libs/shared-embed/src/lib/methods/reload-dashboard.ts
var reloadDashboard = (dashboardComponent, iframe) => {
  if (iframe) {
    iframe.contentWindow.postMessage(
      { action: "reloadDashboard", _version: dashboardComponent.VERSION },
      "*"
    );
    return Promise.resolve();
  }
  return Promise.reject(new Error("Cannot retrieve contentWindow."));
};

// libs/embed-libs/shared-embed/src/lib/methods/set-authorization.ts
var setAuthorization = (dashboardComponent, iframe, key, token) => {
  if (iframe) {
    iframe.contentWindow.postMessage(
      {
        action: "setAuthorization",
        key,
        token,
        _version: dashboardComponent.VERSION
      },
      "*"
    );
    return Promise.resolve();
  }
  return Promise.reject(new Error("Cannot retrieve contentWindow."));
};

// libs/embed-libs/shared-embed/src/lib/methods/set-edit-mode.ts
var setEditMode = (dashboardComponent, iframe, editMode) => {
  if (iframe && iframe.contentWindow) {
    const requestId = uuidv4();
    if (dashboardComponent.params.editMode === editMode) {
      return Promise.reject(
        new Error("editMode parameter is currently already set to " + editMode)
      );
    } else if (editMode !== "editFull" && editMode !== "editLimited" && editMode !== "view") {
      return Promise.reject(
        new Error(
          "The editMode parameter must be one of the following values: 'editFull', 'editLimited' or 'view'."
        )
      );
    }
    iframe.contentWindow.postMessage(
      {
        action: "setEditMode",
        editMode,
        _version: dashboardComponent.VERSION,
        requestId
      },
      "*"
    );
    return new Promise((resolve, reject) => {
      dashboardComponent.promises[requestId] = { resolve, reject };
    });
  }
  return Promise.reject(new Error("Cannot retrieve contentWindow."));
};

// libs/embed-libs/shared-embed/src/lib/methods/set-filters.ts
var setFilters = (dashboardComponent, iframe, itemId, filters) => {
  if (iframe) {
    const requestId = uuidv4();
    iframe.contentWindow.postMessage(
      {
        action: "setFilters",
        itemId,
        filters,
        _version: dashboardComponent.VERSION,
        requestId
      },
      "*"
    );
    return new Promise((resolve, reject) => {
      dashboardComponent.promises[requestId] = { resolve, reject };
      setTimeout(() => {
        if (dashboardComponent.promises[requestId]) {
          const errorMessage = "setFilters request timed out.";
          dashboardComponent.promises[requestId].reject(
            new Error(errorMessage)
          );
          delete dashboardComponent.promises[requestId];
        }
      }, 2e3);
    });
  }
  return Promise.reject();
};

// libs/embed-libs/shared-embed/src/lib/methods/set-preview.ts
var setPreview = (dashboardComponent, iframe, preview) => {
  if (iframe) {
    const requestId = uuidv4();
    iframe.contentWindow.postMessage(
      {
        action: "setPreview",
        preview,
        requestId,
        _version: dashboardComponent.VERSION
      },
      "*"
    );
    return new Promise((resolve, reject) => {
      dashboardComponent.promises[requestId] = { resolve, reject };
      setTimeout(() => {
        if (dashboardComponent.promises[requestId]) {
          const errorMessage = "setPreview request timed out.";
          dashboardComponent.promises[requestId].reject(
            new Error(errorMessage)
          );
          delete dashboardComponent.promises[requestId];
        }
      }, 2e3);
    });
  }
  return Promise.reject(new Error("Cannot retrieve contentWindow."));
};

// libs/embed-libs/shared-embed/src/lib/service/calculate-dimensions.ts
var _setCalculatedDimensions = (dashboardComponent) => {
  if (!dashboardComponent.dimensions) {
    dashboardComponent.params.error = true;
    _handleError("Got no valid dimensions.", dashboardComponent.params);
    return;
  }
  const dashboardDimensionKeys = Object.keys(
    dashboardComponent.dimensions
  );
  const availableScreenModeExtents = [];
  let currentMode;
  let currentWidth = 0;
  let currentHeight = 0;
  if (!dashboardComponent.params.switchScreenModeOnResize && dashboardComponent.currentScreenMode) {
    dashboardComponent.params.screenMode = dashboardComponent.currentScreenMode;
  }
  if (dashboardComponent.dimensions && dashboardDimensionKeys?.[0] === "fixed") {
    currentMode = "fixed";
    currentWidth = dashboardComponent.dimensions.fixed[0];
    currentHeight = dashboardComponent.dimensions.fixed[1];
  } else {
    const screenModes = [
      "mobile",
      "tablet",
      "desktop",
      "largeScreen"
    ];
    if (dashboardComponent.params.itemEmbedding) {
      const [firstMatch] = dashboardDimensionKeys;
      let match = cloneDeep(firstMatch);
      for (const screenMode of screenModes) {
        const found = dashboardDimensionKeys.find((key) => key === screenMode);
        if (found) {
          match = cloneDeep(found);
        } else {
          dashboardComponent.dimensions[screenMode] = dashboardComponent.dimensions[match];
        }
      }
    }
    for (const key of dashboardDimensionKeys) {
      if (screenModes.includes(key)) {
        const screenMode = EXTENTS.find((extent) => extent.mode === key);
        availableScreenModeExtents.push({
          ...screenMode,
          height: dashboardComponent.dimensions[key][1] || 50
        });
      }
    }
    if (!availableScreenModeExtents.map((screenModeExtent) => screenModeExtent.mode).includes(dashboardComponent.params.screenMode)) {
      dashboardComponent.params.screenMode = "auto";
    }
    if (dashboardComponent.params.screenMode === "auto") {
      availableScreenModeExtents.sort(
        (a, b) => screenModes.indexOf(a.mode) - screenModes.indexOf(b.mode)
      );
      for (const screenModeExtent of availableScreenModeExtents) {
        const [screenModeExtentMinWidth, screenModeExtentMaxWidth] = screenModeExtent.width;
        if (dashboardComponent.params.itemEmbedding && dashboardComponent.params.itemDimensions && dashboardComponent.params.itemDimensions.width !== "auto" && dashboardComponent.params.itemDimensions.height === "auto") {
          if (screenModeExtentMinWidth < dashboardComponent.params.itemDimensions.width) {
            currentMode = screenModeExtent.mode;
            currentWidth = Number.parseInt(
              dashboardComponent.params.itemDimensions.width,
              10
            );
            currentHeight = dashboardComponent.dimensions[currentMode][1];
          }
        } else {
          if (screenModeExtentMinWidth < dashboardComponent.containerWidth) {
            currentMode = screenModeExtent.mode;
            if (dashboardComponent.params.itemEmbedding) {
              currentWidth = dashboardComponent.params.itemDimensions?.width && dashboardComponent.params.itemDimensions?.width !== "auto" ? Number.parseInt(
                dashboardComponent.params.itemDimensions.width,
                10
              ) : Math.min(
                dashboardComponent.containerWidth,
                screenModeExtentMaxWidth
              );
              currentHeight = dashboardComponent.params.itemDimensions?.height && dashboardComponent.params.itemDimensions?.height !== "auto" ? Number.parseInt(
                dashboardComponent.params.itemDimensions.height,
                10
              ) : dashboardComponent.dimensions[currentMode][1];
              if (dashboardComponent.params.itemDimensions && dashboardComponent.params.itemDimensions.width !== "auto" && dashboardComponent.params.itemDimensions.height === "auto") {
                currentWidth = Number.parseInt(
                  dashboardComponent.params.itemDimensions.width,
                  10
                );
                currentHeight = dashboardComponent.dimensions[currentMode][1];
              }
            } else {
              currentWidth = Math.max(
                Math.min(
                  screenModeExtentMaxWidth,
                  dashboardComponent.containerWidth
                ),
                screenModeExtentMinWidth
              );
              currentHeight = screenModeExtent.height;
            }
          }
        }
      }
    } else {
      const {
        height: chosenModeHeight,
        width: [chosenModeMinWidth, chosenModeMaxWidth]
      } = availableScreenModeExtents.find(
        (d) => d.mode === dashboardComponent.params.screenMode
      );
      currentMode = dashboardComponent.params.screenMode;
      currentWidth = Math.max(
        Math.min(chosenModeMaxWidth, dashboardComponent.containerWidth),
        chosenModeMinWidth
      );
      currentHeight = chosenModeHeight;
      if (dashboardComponent.params.itemEmbedding) {
        if (dashboardComponent.params.itemDimensions?.width && dashboardComponent.params.itemDimensions?.width !== "auto") {
          currentWidth = Number.parseInt(
            dashboardComponent.params.itemDimensions.width,
            10
          );
        }
        if (dashboardComponent.params.itemDimensions?.height && dashboardComponent.params.itemDimensions?.height !== "auto") {
          currentHeight = Number.parseInt(
            dashboardComponent.params.itemDimensions.height,
            10
          );
        }
      }
    }
    if (!currentMode && availableScreenModeExtents.length > 0) {
      const [lowestModeExtent] = availableScreenModeExtents;
      currentMode = lowestModeExtent.mode;
      currentWidth = lowestModeExtent.width[0];
      currentHeight = lowestModeExtent.height;
    }
  }
  dashboardComponent.currentScreenMode = currentMode;
  const style = {
    height: currentHeight === 0 ? "100%" : `${String(currentHeight)}px`,
    width: currentWidth === 0 ? "100%" : `${String(currentWidth)}px`,
    opacity: 1
  };
  const dashboardEditModes = ["editFull", "editLimited"];
  if (dashboardEditModes.includes(dashboardComponent.params.editMode)) {
    style.height = "100%";
    style.width = "100%";
  } else if (dashboardComponent.params.itemEmbedding && dashboardComponent.params.itemDimensions) {
    style.height = dashboardComponent.params.itemDimensions.height === "auto" ? style.height : `${String(dashboardComponent.params.itemDimensions.height).replace(
      "px",
      ""
    )}px`;
    style.width = dashboardComponent.params.itemDimensions.width === "auto" ? style.width : `${String(dashboardComponent.params.itemDimensions.width).replace(
      "px",
      ""
    )}px`;
  } else {
    style.height = currentHeight === 0 ? "100%" : `${String(currentHeight)}px`;
    style.width = currentWidth === 0 ? "100%" : `${String(currentWidth)}px`;
  }
  dashboardComponent.currentScreenMode = currentMode;
  dashboardComponent.iframeStyle = style;
};

// libs/embed-libs/shared-embed/src/lib/service/extend-and-validate.ts
var _extendAndValidate = (dashboardContent) => {
  const defaultKeys = Object.keys(
    DEFAULT_PARAMETERS
  );
  const errorMessages = [];
  const requiredStringParams = [
    "appServer",
    "language",
    "apiHost"
  ];
  const requiredStringOrEmptyParams = [
    "key",
    "token",
    "screenMode",
    "timezoneId",
    "itemId",
    "container",
    "loaderBackground",
    "loaderFontColor",
    "loaderSpinnerColor",
    "loaderSpinnerBackground"
  ];
  const objectParams = ["itemDimensions"];
  const screenModes = [
    "mobile",
    "tablet",
    "desktop",
    "largeScreen",
    "fixed",
    "auto"
  ];
  for (const key of defaultKeys) {
    if (dashboardContent.params[key] === null) {
      delete dashboardContent.params[key];
    }
  }
  dashboardContent.params = defaultsDeep(
    dashboardContent.params,
    DEFAULT_PARAMETERS
  );
  if ((!dashboardContent.params.dashboardId || typeof dashboardContent.params.dashboardId !== "string") && (!dashboardContent.params.dashboardSlug || typeof dashboardContent.params.dashboardSlug !== "string")) {
    delete dashboardContent.params.dashboardId;
    delete dashboardContent.params.dashboardSlug;
  }
  for (const key of requiredStringParams) {
    if (typeof dashboardContent.params[key] !== "string") {
      delete dashboardContent.params[key];
      errorMessages.push(`${key} needs to be of type string.`);
    }
  }
  for (const key of requiredStringOrEmptyParams) {
    if (typeof dashboardContent.params[key] !== "string" && dashboardContent.params[key] !== null && dashboardContent.params[key] !== void 0) {
      delete dashboardContent.params[key];
      errorMessages.push(`${key} needs to be of type string or empty.`);
    }
  }
  if (dashboardContent.params.screenMode && !screenModes.includes(dashboardContent.params.screenMode)) {
    const validTypesString = screenModes.map((mode) => `"${mode}"`).join(", ");
    errorMessages.push(
      `"screenMode" needs should be one of these types: ${validTypesString}`
    );
    dashboardContent.params.screenMode = "auto";
  }
  if (dashboardContent.params.itemId) {
    dashboardContent.params.itemEmbedding = true;
  }
  for (const key of objectParams) {
    if (typeof dashboardContent.params[key] !== "object" && dashboardContent.params[key] !== null) {
      delete dashboardContent.params[key];
      errorMessages.push(`${key} needs to be of type object or empty.`);
    }
  }
  if (typeof dashboardContent.params.switchScreenModeOnResize !== "boolean") {
    errorMessages.push("switchScreenModeOnResize needs to be of type boolean.");
    dashboardContent.params.switchScreenModeOnResize = true;
  }
  if (dashboardContent.params.itemDimensions) {
    const itemDimensionsKeys = [
      "width",
      "height"
    ];
    for (const key of itemDimensionsKeys) {
      if (!["string", "number"].includes(
        typeof dashboardContent.params.itemDimensions[key]
      ) && dashboardContent.params.itemDimensions[key] !== null) {
        errorMessages.push(
          `itemDimensions ${key} needs to be of type string, number or empty.`
        );
      }
    }
  }
  dashboardContent.params = defaultsDeep(
    dashboardContent.params,
    DEFAULT_PARAMETERS
  );
  if (dashboardContent.params.screenMode && dashboardContent.params.screenMode !== "auto") {
    dashboardContent.params.switchScreenModeOnResize = false;
  }
  if (dashboardContent.params.itemDimensions.width !== "auto") {
    dashboardContent.params.itemDimensions.width = Number.parseInt(
      `${dashboardContent.params.itemDimensions.width}`.replace("px", ""),
      10
    ) || "auto";
  }
  if (dashboardContent.params.itemDimensions.height !== "auto") {
    dashboardContent.params.itemDimensions.height = Number.parseInt(
      `${dashboardContent.params.itemDimensions.height}`.replace("px", ""),
      10
    ) || "auto";
  }
  dashboardContent.params.itemEmbedding = !!dashboardContent.params.itemId;
  if (dashboardContent.params.error || errorMessages.length > 0) {
    _handleError(errorMessages.join("\n"), dashboardContent.params);
  }
};

// libs/embed-libs/shared-embed/src/lib/helpers/remote-federation.ts
var remotesMap = {
  // "remote_app": { url: "http://localhost:4201/remoteEntry.mjs", format: "esm", from: "vite" },
};
var loadJS = async (url, fn) => {
  const resolvedUrl = typeof url === "function" ? await url() : url;
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.addEventListener("load", fn);
  script.src = resolvedUrl;
  document.querySelectorAll("head")[0].append(script);
};
var wrapShareModule = (remoteFrom) => ({});
async function __federationMethodEnsure(remoteId) {
  const remote = remotesMap[remoteId];
  if (remote.inited) {
    return remote.lib;
  }
  if (remote.format === "var") {
    return new Promise((resolve) => {
      const callback = () => {
        if (!remote.inited) {
          remote.lib = window[remoteId];
          remote.lib.init(wrapShareModule(remote.from));
          remote.inited = true;
        }
        resolve(remote.lib);
      };
      return loadJS(remote.url, callback);
    });
  } else if (["esm", "systemjs"].includes(remote.format)) {
    return new Promise((resolve, reject) => {
      const getUrl = typeof remote.url === "function" ? remote.url : () => Promise.resolve(remote.url);
      getUrl().then((url) => {
        import(
          /* @vite-ignore */
          /* webpackIgnore: true */
          url
        ).then((lib) => {
          if (!remote.inited) {
            const shareScope = wrapShareModule(remote.from);
            lib.init(shareScope);
            remote.lib = lib;
            remote.lib.init(shareScope);
            remote.inited = true;
          }
          resolve(remote.lib);
        }).catch(reject);
      });
    });
  }
}
function __federationMethodWrapDefault(module, need) {
  if (!(module == null ? void 0 : module.default) && need) {
    const obj = /* @__PURE__ */ Object.create(null);
    obj.default = module;
    obj.__esModule = true;
    return obj;
  }
  return module;
}
async function __federationMethodGetRemote(remoteName, componentName) {
  return __federationMethodEnsure(remoteName).then((remote) => remote.get(componentName).then((factory) => factory()));
}

// libs/embed-libs/embed/src/lib/dashboard-component/dashboard-component.ts
import {
  html,
  LitElement
} from "lit";
import {
  customElement,
  property,
  query,
  state
} from "lit/decorators.js";
import {
  styleMap
} from "lit/directives/style-map.js";

// libs/embed-libs/embed/package.json
var version = "5.0.7";

// libs/embed-libs/embed/src/lib/luzmo-service.ts
var LuzmoService = class {
  constructor() {
    this._components = [];
  }
};
var luzmo_service_default = new LuzmoService();

// libs/embed-libs/embed/src/lib/helper/event-bus-handler.ts
var _setEventHandler = () => {
  if (typeof window.__luzmoMessageHandler === "function") {
    return;
  }
  window.__luzmoMessageHandler = (event) => {
    const dashboardComponent = luzmo_service_default._components.find(
      (c) => event.data.name === c._iframeId
    );
    if (!dashboardComponent) {
      return;
    }
    switch (event.data?.type) {
      case "load": {
        dashboardComponent.dispatchEvent(
          new CustomEvent("load", { detail: { data: event.data } })
        );
        if (dashboardComponent._loadTimeoutHandle) {
          clearTimeout(dashboardComponent._loadTimeoutHandle);
          dashboardComponent._loadTimeoutHandle = void 0;
        }
        dashboardComponent.iframeLoaded = true;
        dashboardComponent.dimensions = event.data.dimensions;
        dashboardComponent._calculateDimAfterDashboardLoaded();
        break;
      }
      case "error": {
        dashboardComponent.dashboardError = true;
        if (dashboardComponent._loadTimeoutHandle) {
          clearTimeout(dashboardComponent._loadTimeoutHandle);
          dashboardComponent._loadTimeoutHandle = void 0;
        }
        dashboardComponent.iframeLoaded = true;
        dashboardComponent._displayError();
        break;
      }
      case "data": {
        resolvePromise(
          dashboardComponent,
          event.data.requestId,
          event.data.data
        );
        break;
      }
      case "filters": {
        resolvePromise(
          dashboardComponent,
          event.data.requestId,
          event.data.filters
        );
        break;
      }
      case "getAccessibleDashboards": {
        resolvePromise(
          dashboardComponent,
          event.data.requestId,
          event.data.accessibleDashboards
        );
        break;
      }
      case "dashboardAction": {
        dashboardComponent.dispatchEvent(
          new CustomEvent("dashboardAction", { detail: { data: event.data } })
        );
        break;
      }
      case "export": {
        if (event.data.error) {
          rejectPromise(
            dashboardComponent,
            event.data.requestId,
            event.data
          );
        } else {
          dashboardComponent.dispatchEvent(
            new CustomEvent("exported", { detail: { data: event.data } })
          );
          resolvePromise(
            dashboardComponent,
            event.data.requestId,
            event.data
          );
        }
        break;
      }
      case "changedFilters": {
        dashboardComponent.dispatchEvent(
          new CustomEvent("changedFilters", { detail: { data: event.data } })
        );
        break;
      }
      case "customEvent": {
        dashboardComponent.dispatchEvent(
          new CustomEvent("customEvent", { detail: { data: event.data } })
        );
        break;
      }
      case "chartsRendered":
      case "itemsRendered": {
        event.data.type = "itemsRendered";
        dashboardComponent.dispatchEvent(
          new CustomEvent("itemsRendered", { detail: { data: event.data } })
        );
        break;
      }
      case "setEditMode": {
        if (event.data.error) {
          rejectPromise(
            dashboardComponent,
            event.data.requestId,
            event.data
          );
        } else {
          resolvePromise(
            dashboardComponent,
            event.data.requestId,
            event.data
          );
          dashboardComponent.params.editMode = event.data.editMode;
          dashboardComponent._containerStyle = containerStyles(dashboardComponent);
          if (dashboardComponent.dimensions) {
            _setCalculatedDimensions(dashboardComponent);
          }
        }
        break;
      }
      case "setFilters": {
        event.data.error ? rejectPromise(
          dashboardComponent,
          event.data.requestId,
          event.data
        ) : resolvePromise(
          dashboardComponent,
          event.data.requestId,
          event.data
        );
        break;
      }
      case "setPreview": {
        event.data.error ? rejectPromise(
          dashboardComponent,
          event.data.requestId,
          event.data
        ) : resolvePromise(
          dashboardComponent,
          event.data.requestId,
          event.data
        );
        break;
      }
    }
  };
  window.addEventListener("message", window.__luzmoMessageHandler, false);
};

// libs/embed-libs/embed/src/lib/dashboard-component/dashboard-styles.ts
import { css } from "lit";
var dashboardStyles = css`
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  :host {
    position: relative;
    width: 100%;
  }

  .luzmo-embed-dashboard {
    background: transparent;
    padding: 0;
    border: 0;
  }

  .luzmo-container-loader {
    width: 100%;
    position: relative;
  }

  .luzmo-lc {
    margin: 0 auto;
  }

  .luzmo-loading-message {
    width: 100%;
    height: 20px;
    text-align: center;
    margin-bottom: 16px;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 14px;
  }

  .luzmo-loading-circle {
    box-sizing: border-box;
    margin: 16px auto;
    position: relative;
    text-indent: -9999em;
    animation: spin 0.6s infinite linear;
  }

  .luzmo-loading-circle,
  .luzmo-loading-circle:after {
    border-radius: 50%;
    width: 32px;
    height: 32px;
  }

  .itemEmbedding:after {
    width: 24px;
    height: 24px;
  }

  .luzmo-error {
    background: transparent;
    padding: 48px 0;
    margin: 0 auto;
    width: 80%;
    border: 0;
    text-align: center;
    min-height: 192px;
  }

  .dashboard-error {
    font-size: 30px;
    background: transparent;
    padding: 48px 0;
    margin: 0 auto;
    width: 80%;
    border: 0;
    text-align: center;
    min-height: 192px;
  }

  .luzmo-loader {
    top: 0;
    left: 0;
    width: 100%;
    min-height: 400px;
    position: absolute;
    transition-duration: 0.3s;
  }
`;

// libs/embed-libs/embed/src/lib/dashboard-component/dashboard-component.ts
var LuzmoDashboard = class extends LitElement {
  constructor(inputParameters) {
    super();
    this.language = "auto";
    this.screenMode = "auto";
    this.switchScreenModeOnResize = true;
    this.editMode = "view";
    this.experimental = false;
    this.iframeStyle = {};
    this._containerStyle = {};
    this._loaderStyle = {};
    this._lcStyle = {};
    this._loadingCircleStyle = {};
    this._containerLoaderStyle = {};
    this._loaderMsg = "";
    this._itemEmbedding = false;
    this.browserError = false;
    this.browserErrorMsg = "";
    this.dashboardError = false;
    this.browserNotSupported = [];
    this.VERSION = version + "-wc-luzmo";
    this.isLibraryLoaded = false;
    this.attributesMap = {
      dashboardId: "dashboard-id",
      dashboardSlug: "dashboard-slug",
      itemId: "item-id",
      language: "language",
      qeVersion: "qe-version",
      screenMode: "screen-mode",
      switchScreenModeOnResize: "switch-screen-mode-on-resize",
      authKey: "auth-key",
      authToken: "auth-token",
      editMode: "edit-mode",
      mainColor: "main-color",
      accentColor: "accent-color",
      loaderBackground: "loader-background",
      loaderFontColor: "loader-font-color",
      loaderSpinnerColor: "loader-spinner-color",
      loaderSpinnerBackground: "loader-spinner-background",
      appServer: "app-server",
      apiHost: "api-host",
      itemDimensions: "item-dimensions",
      timezoneId: "timezone-id"
    };
    this.loaderSize = 32;
    this.borderWidth = 3;
    this.minHeight = 400;
    this._containerId = uuidv4();
    this._iframeId = `luzmo-dashboard-${this._containerId}`;
    this.iframeLoaded = false;
    this.promises = {};
    this.setInputParameters(inputParameters);
    this.params = this._setOptions();
    this._onResize = () => {
      if (this.shadowRoot?.querySelector(".dashboard-container")) {
        this.containerWidth = this.container.clientWidth;
        if (this.params.switchScreenModeOnResize && this.params.screenMode === "auto") {
          for (const d of EXTENTS) {
            if (d.width[0] <= window.innerWidth && window.innerWidth <= d.width[1]) {
              this.currentScreenMode = d.mode;
            }
          }
        }
        if (this.iframeLoaded) {
          this._calculateDimAfterDashboardLoaded();
        }
      }
    };
    this._resizeObserver = new ResizeObserver((entries) => {
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || entries.length === 0) {
          return;
        }
        this._onResize();
      });
    });
  }
  loadLibrary(appServer) {
    if (remotesMap[appServer]) {
      return Promise.resolve(remotesMap[appServer].module);
    }
    remotesMap[appServer] = { url: appServer?.startsWith("http://localhost") ? `${removeTrailingSlash(appServer)}/remoteEntry.mjs` : `${removeTrailingSlash(appServer)}/dashboard-app/remoteEntry.mjs`, format: "esm", from: "vite", module: void 0 };
    return __federationMethodGetRemote(appServer, "./DashboardApp").then((module) => {
      const wrappedModule = __federationMethodWrapDefault(module, true);
      remotesMap[appServer].module = wrappedModule;
      return wrappedModule;
    });
  }
  setInputParameters(inputParameters) {
    if (!inputParameters) {
      return;
    }
    const params = [
      "dashboardId",
      "dashboardSlug",
      "itemId",
      "language",
      "qeVersion",
      "screenMode",
      "switchScreenModeOnResize",
      "accentColor",
      "mainColor",
      "authToken",
      "authKey",
      "editMode",
      "loaderBackground",
      "loaderFontColor",
      "loaderSpinnerColor",
      "loaderSpinnerBackground",
      "timezoneId",
      "itemDimensions",
      "apiHost"
    ];
    for (const key of params) {
      const value = inputParameters[key];
      if (value) {
        this[key] = value;
      }
    }
    if (inputParameters.experimental) {
      this.experimental = inputParameters.experimental;
    }
    if (inputParameters.appServer) {
      this.appServer = addTrailingSlash(inputParameters.appServer);
    }
  }
  // Set resize event listener
  connectedCallback() {
    super.connectedCallback();
  }
  // Set resize event listener
  disconnectedCallback() {
    super.disconnectedCallback();
    this._resizeObserver.disconnect();
    for (const promiseKey of Object.keys(this.promises)) {
      this.promises[promiseKey].reject(
        new Error("Dashboard component was removed")
      );
    }
  }
  firstUpdated() {
    this._loaderMsg = getLoader(this)?.loadingMsg;
    this._loaderStyles();
    luzmo_service_default._components.push(this);
    this.initComponent();
  }
  initComponent() {
    this.params = this._setOptions();
    if (this.getIsViewMode()) {
      this.loadLibrary(this.params.appServer).then(async () => {
        this.isLibraryLoaded = true;
        await this.updateComplete;
        const oldReference = this.renderRoot.querySelector("dashboard-component");
        this.dashboardReference = oldReference.cloneNode(true);
        oldReference.replaceWith(this.dashboardReference);
        this.dashboardReference.addEventListener("load", (payload) => {
          setTimeout(() => {
            this.containerWidth = this.dashboardReference.offsetWidth;
            this.dimensions = payload.detail.dimensions;
            _setCalculatedDimensions(this);
            this.dispatchEvent(new CustomEvent("load", payload.detail));
          });
        });
        this.dashboardReference.addEventListener("itemsRendered", (payload) => this.dispatchEvent(new CustomEvent("itemsRendered", payload.detail)));
        this.dashboardReference.addEventListener("customEvent", (payload) => this.dispatchEvent(new CustomEvent("customEvent", payload.detail)));
        this.dashboardReference.addEventListener("changedFilters", (payload) => this.dispatchEvent(new CustomEvent("changedFilters", payload.detail)));
        this.dashboardReference.addEventListener("dashboardAction", (payload) => this.dispatchEvent(new CustomEvent("dashboardAction", payload.detail)));
        this.dashboardReference.addEventListener("export", (payload) => this.dispatchEvent(new CustomEvent("exported", payload.detail)));
        this.setAllAttributes();
      });
    } else {
      this.containerWidth = this.container?.clientWidth;
      _extendAndValidate(this);
      _browserCheck(this);
      this._setupLoader();
      if (!this.params.error) {
        this._loaderStyles();
        _setEventHandler();
        this._iframeUrl = createIframeUrl(this);
        this.iframe?.setAttribute("src", this._iframeUrl);
        this.iframeStyle = calculateIframeStyles(this);
      }
      if (this.container) {
        this._resizeObserver.observe(this.container);
      }
    }
  }
  setAllAttributes() {
    if (this.dashboardReference) {
      for (const key in this.attributesMap) {
        if (!["authKey", "authToken", "apiHost", "itemDimensions"].includes(key) && this.params[key]) {
          this.dashboardReference.setAttribute(this.attributesMap[key], this.params[key]);
        }
        if (this.params.itemDimensions) {
          this.dashboardReference.setAttribute("item-dimensions", JSON.stringify(this.params.itemDimensions));
        }
        if (this.params.apiHost) {
          this.dashboardReference.setAttribute("api-host", removeTrailingSlash(this.params.apiHost));
        }
        if (this.params.key) {
          this.dashboardReference.setAttribute("auth-key", this.params.key);
        }
        if (this.params.token) {
          this.dashboardReference.setAttribute("auth-token", this.params.token);
        }
      }
    }
  }
  // Reload dashboard when triggerproperty changes
  updated(changedProperties) {
    const triggerProperties = /* @__PURE__ */ new Set([
      "dashboardId",
      "dashboardSlug",
      "itemId",
      "language",
      "qeVersion",
      "editMode",
      "screenMode",
      "switchScreenModeOnResize",
      "authToken",
      "authKey",
      "appServer",
      "timezoneId",
      "itemDimensions"
    ]);
    if (this.getIsViewMode()) {
      if (this.dashboardReference) {
        for (const [propertyName] of changedProperties.entries()) {
          if (propertyName === "appSever") {
            this.loadLibrary(changedProperties[propertyName]).then(async () => {
              this.isLibraryLoaded = true;
              await this.updateComplete;
              this.dashboardReference = this.renderRoot.querySelector("dashboard-component");
              this.setAllAttributes();
            });
          } else if (this.attributesMap[propertyName]) {
            const mappedAttributeName = this.attributesMap[propertyName] ?? propertyName;
            const attributeValue = typeof this[propertyName] === "object" ? JSON.stringify(this[propertyName]) : this[propertyName]?.toString() || this[propertyName];
            this.dashboardReference.setAttribute(mappedAttributeName, attributeValue);
          }
        }
      }
    } else {
      for (const [propertyName] of changedProperties.entries()) {
        if (triggerProperties.has(propertyName) && propertyName !== "editMode") {
          this.iframeLoaded = false;
          if (this._loadTimeoutHandle) {
            clearTimeout(this._loadTimeoutHandle);
          }
          this._loadTimeoutHandle = setTimeout(() => {
            console.error(
              "Failed to load dashboard, appServer is likely down or unreachable."
            );
          }, 15 * 1e3);
          this.params = this._setOptions();
          _extendAndValidate(this);
          this._setupLoader();
          this._loaderStyles();
          this._iframeUrl = createIframeUrl(this);
          if (this.iframe) {
            this._updateIframeUrl();
          }
          this.iframeStyle = calculateIframeStyles(this);
        } else if (triggerProperties.has(propertyName) && propertyName === "editMode") {
          if (this.iframeLoaded) {
            this.setEditMode(this.editMode);
          }
          this.params = this._setOptions();
        }
      }
    }
  }
  // Set params
  _setOptions() {
    const defaultParameters = {
      dashboardId: this.dashboardId,
      dashboardSlug: this.dashboardSlug
    };
    if (this.itemId) {
      defaultParameters.itemId = this.itemId;
      this._itemEmbedding = true;
    } else {
      this._itemEmbedding = false;
    }
    if (this.language) {
      defaultParameters.language = this.language;
    }
    if (this.qeVersion) {
      defaultParameters.qeVersion = this.qeVersion;
    }
    if (this.screenMode) {
      defaultParameters.screenMode = this.screenMode;
    }
    defaultParameters.switchScreenModeOnResize = this.switchScreenModeOnResize;
    if (this.authToken) {
      defaultParameters.token = this.authToken;
    }
    if (this.authKey) {
      defaultParameters.key = this.authKey;
    }
    if (this.editMode) {
      defaultParameters.editMode = this.editMode;
    }
    if (this.mainColor) {
      defaultParameters.mainColor = this.mainColor;
    }
    if (this.accentColor) {
      defaultParameters.accentColor = this.accentColor;
    }
    if (this.loaderBackground) {
      defaultParameters.loaderBackground = this.loaderBackground;
    }
    if (this.loaderFontColor) {
      defaultParameters.loaderFontColor = this.loaderFontColor;
    }
    if (this.loaderSpinnerColor) {
      defaultParameters.loaderSpinnerColor = this.loaderSpinnerColor;
    }
    if (this.loaderSpinnerBackground) {
      defaultParameters.loaderSpinnerBackground = this.loaderSpinnerBackground;
    }
    if (this.timezoneId) {
      defaultParameters.timezoneId = this.timezoneId;
    }
    if (this.itemDimensions) {
      defaultParameters.itemDimensions = this.itemDimensions;
    }
    if (this.appServer) {
      this.appServer = this.getIsViewMode() ? removeTrailingSlash(this.appServer) : addTrailingSlash(this.appServer);
      defaultParameters.appServer = this.appServer;
    } else {
      this.appServer = addTrailingSlash(
        DEFAULT_PARAMETERS.appServer
      );
      defaultParameters.appServer = this.appServer;
    }
    if (this.apiHost) {
      this.apiHost = this.getIsViewMode() ? removeTrailingSlash(this.apiHost) : addTrailingSlash(this.apiHost);
      defaultParameters.apiHost = this.apiHost;
    } else {
      this.apiHost = this.appServer.includes("luzmo.com") ? this.appServer.replace("app", "api") : this.appServer;
      defaultParameters.apiHost = this.apiHost;
    }
    return defaultParameters;
  }
  _updateIframeUrl() {
    updateIframeUrl(this.iframe, this._iframeUrl);
  }
  // Setup loader / browser error
  _setupLoader() {
    const data = getLoader(this);
    this._loaderMsg = data.loadingMsg;
    if (data.errorMsg) {
      this.browserError = true;
      this.browserErrorMsg = data.errorMsg;
      this._displayError();
    }
  }
  _displayError() {
    if (this.dashboardError) {
      this._loaderStyles();
      this.iframeStyle.opacity = 1;
    }
    if (this.browserError) {
      this._containerStyle.display = "none";
    }
  }
  _calculateDimAfterDashboardLoaded() {
    this.dashboardError = false;
    this._loaderStyles();
    _setCalculatedDimensions(this);
  }
  // Set loader styles
  _loaderStyles() {
    this._containerStyle = containerStyles(this);
    this._loaderStyle = loaderStyles(this);
    this._loadingCircleStyle = plStyles(this);
    this._containerLoaderStyle = containerLoaderStyles(this);
    this._lcStyle = lcStyles(this);
  }
  static get styles() {
    return [dashboardStyles];
  }
  render() {
    let toBeRenderedHTML = html``;
    const loader = html`
      <div
              class="luzmo-container-loader"
              id="luzmo-container-loader-${this._containerId}"
              style=${styleMap(
      this._containerLoaderStyle
    )}
            >
              <div
                class="luzmo-loader"
                id="luzmo-loader-${this._containerId}"
                style=${styleMap(this._loaderStyle)}
              >
                <div
                  class="luzmo-lc"
                  style=${styleMap(this._lcStyle)}
                >
                  <div
                    class="luzmo-loading-circle"
                    style=${styleMap(
      this._loadingCircleStyle
    )}
                  ></div>
                  ${this._itemEmbedding ? "" : html`
      <div
                               class="luzmo-loading-message"
                               style=${styleMap({ color: this.loaderFontColor })}
                             >
                               ${this._loaderMsg}
                             </div>
    `}
                </div>
              </div>
            </div>
    `;
    if (this.getIsViewMode()) {
      toBeRenderedHTML = this.isLibraryLoaded ? html`
          ${this.dashboardId || this.dashboardSlug ? html`<dashboard-component dashboard-id="${this.params.dashboardId}" app-server="${this.params.appServer}" api-host="${this.params.apiHost}"></dashboard-component>` : html`
            <div id="luzmo-error-${this._containerId}">
                       <h3 class="luzmo-error">${this.browserErrorMsg}</h3>
                     </div>
          `}
        ` : html`${loader}`;
    } else {
      toBeRenderedHTML = html`
          ${this.dashboardId || this.dashboardSlug ? html`
      ${loader}
      <iframe
        class="luzmo-embed-dashboard"
        id="${this._iframeId}"
        name="${this._iframeId}"
        style=${styleMap(this.iframeStyle)}
        src="${this._iframeUrl}"
        frameborder="0"
      ></iframe>
    ` : html`<!-- the dashboard will inititialize when you provide a dashboardSlug or a dashboardId -->`}
        ${this.browserError ? html`
      <div id="luzmo-error-${this._containerId}">
                 <h3 class="luzmo-error">${this.browserErrorMsg}</h3>
               </div>
    ` : ""}
      `;
    }
    return html`
      <div
        class="dashboard-container"
        style=${styleMap(Object.assign({}, this._containerStyle, {
      width: this.iframeStyle.width ?? "100%",
      height: this.iframeStyle.height ?? "100%"
    }))}
      >
        ${toBeRenderedHTML}
      </div>
    `;
  }
  getDashboards() {
    return new Promise(
      (resolve) => resolve(luzmo_service_default._components)
    );
  }
  // Public methods
  getData(itemId) {
    if (this.getIsViewMode() && this.dashboardReference) {
      return this.dashboardReference.getData(itemId);
    }
    if (!this.getIsViewMode()) {
      return getData(this, this.iframe, itemId);
    }
    return Promise.reject();
  }
  getFilters() {
    if (this.getIsViewMode() && this.dashboardReference) {
      return this.dashboardReference.getFilters();
    }
    if (!this.getIsViewMode()) {
      return getFilters(this, this.iframe);
    }
    return Promise.reject();
  }
  setFilters(itemId, filters) {
    if (this.getIsViewMode() && this.dashboardReference) {
      return this.dashboardReference.setFilters(itemId, filters);
    }
    if (!this.getIsViewMode()) {
      return setFilters(this, this.iframe, itemId, filters);
    }
    return Promise.reject();
  }
  setAuthorization(key, token) {
    if (this.getIsViewMode() && this.dashboardReference) {
      return this.dashboardReference.setAuthorization(key, token);
    }
    if (!this.getIsViewMode()) {
      return setAuthorization(this, this.iframe, key, token);
    }
    return Promise.reject();
  }
  refreshData(itemId) {
    if (this.getIsViewMode() && this.dashboardReference) {
      return this.dashboardReference.refreshData(itemId);
    }
    if (!this.getIsViewMode()) {
      return itemId ? refreshData(this, this.iframe, itemId) : refreshData(this, this.iframe);
    }
    return Promise.reject();
  }
  reloadDashboard() {
    if (this.getIsViewMode() && this.dashboardReference) {
      return this.dashboardReference.reloadDashboard();
    }
    if (!this.getIsViewMode()) {
      return reloadDashboard(this, this.iframe);
    }
    return Promise.reject();
  }
  exportDashboard(format) {
    if (this.getIsViewMode() && this.dashboardReference) {
      return this.dashboardReference.exportDashboard(format);
    }
    if (!this.getIsViewMode()) {
      return format ? exportDashboard(this, this.iframe, format) : exportDashboard(this, this.iframe);
    }
    return Promise.reject();
  }
  getAccessibleDashboards() {
    if (!this.getIsViewMode()) {
      return getAccessibleDashboards(this, this.iframe);
    }
    if (this.getIsViewMode() && this.dashboardReference) {
      return this.dashboardReference.getAccessibleDashboards();
    }
    return Promise.reject();
  }
  addFilters(itemId, filters) {
    return this.dashboardReference.addFilters(itemId, filters);
  }
  setEditMode(editMode) {
    if (this.dashboardReference && editMode === "view") {
      this.editMode = "view";
      this.params.editMode = "view";
      this.initComponent();
      return Promise.resolve({
        type: "setEditMode",
        editMode
      });
    }
    if (this.dashboardReference && ["editFull", "editLimited"].includes(editMode)) {
      this.editMode = editMode;
      this.params.editMode = editMode;
      this.initComponent();
      return Promise.resolve({
        type: "setEditMode",
        editMode
      });
    }
    if (this.getIsViewMode() && this.dashboardReference) {
      return this.dashboardReference.setEditMode(editMode);
    }
    if (!this.getIsViewMode()) {
      return setEditMode(this, this.iframe, editMode);
    }
    return Promise.reject();
  }
  setPreview(preview) {
    if (this.getIsViewMode() && this.dashboardReference) {
      return this.dashboardReference.setPreview(preview);
    }
    return setPreview(this, this.iframe, preview);
  }
  getIsViewMode() {
    if (this.experimental && this.params.editMode === "view" || this.params.editMode === void 0) {
      return true;
    }
    return false;
  }
};
__decorateClass([
  query(".dashboard-container")
], LuzmoDashboard.prototype, "container", 2);
__decorateClass([
  query("iframe")
], LuzmoDashboard.prototype, "iframe", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "dashboardId", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "dashboardSlug", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "itemId", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "language", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "qeVersion", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "screenMode", 2);
__decorateClass([
  property({
    converter: {
      fromAttribute: (value) => value === "true",
      toAttribute: String
    }
  })
], LuzmoDashboard.prototype, "switchScreenModeOnResize", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "editMode", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "mainColor", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "accentColor", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "authToken", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "authKey", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "loaderBackground", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "loaderFontColor", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "loaderSpinnerColor", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "loaderSpinnerBackground", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "appServer", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "timezoneId", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "apiHost", 2);
__decorateClass([
  property({ type: Object })
], LuzmoDashboard.prototype, "itemDimensions", 2);
__decorateClass([
  property()
], LuzmoDashboard.prototype, "experimental", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "_containerId", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "_iframeId", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "params", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "_iframeUrl", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "iframeLoaded", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "promises", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "iframeStyle", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "_containerStyle", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "_loaderStyle", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "_lcStyle", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "_loadingCircleStyle", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "_containerLoaderStyle", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "_loaderMsg", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "containerWidth", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "dimensions", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "currentScreenMode", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "_itemEmbedding", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "browserError", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "browserErrorMsg", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "dashboardError", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "browserNotSupported", 2);
__decorateClass([
  property({ attribute: false })
], LuzmoDashboard.prototype, "VERSION", 2);
__decorateClass([
  state()
], LuzmoDashboard.prototype, "isLibraryLoaded", 2);
__decorateClass([
  state()
], LuzmoDashboard.prototype, "dashboardReference", 2);
LuzmoDashboard = __decorateClass([
  customElement("luzmo-dashboard")
], LuzmoDashboard);
export {
  LuzmoDashboard
};
